import { Link } from "@tanstack/react-router";
import { useI18n } from "../i18n/I18nProvider";
import { PageHeader } from "../components/ui/PageHeader";
import { ErrorState } from "../components/ui/ErrorState";
import { ACTION_LINK_CLASS } from "../components/ui/action-link";

export function NotFoundPage() {
  const { t } = useI18n();
  return (
    <main className="mx-auto w-full max-w-2xl px-4 py-10 md:px-6">
      <PageHeader title={t("page.notFound")} />
      <div className="pt-6">
        <ErrorState
          action={
            <Link to="/app" className={ACTION_LINK_CLASS}>
              {t("page.home")}
            </Link>
          }
        >
          {t("page.notFoundText")}
        </ErrorState>
      </div>
    </main>
  );
}
